import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import SEO from "../components/SEO";
import { BLOG_POSTS } from "../data/blog";
import { ArrowRight } from "lucide-react";

export default function BlogIndex() {
  return (
    <main className="pt-28 pb-12" data-testid="blog-index">
      <SEO
        title="Video Blog | Video Production Liverpool | Yellow"
        description="Liverpool video production insights, pricing guides and case studies from Yellow. Real lessons from 1,000+ films made for global brands."
        path="/blog"
        keywords="video blog liverpool, video production blog liverpool, video production insights, video pricing liverpool, corporate video tips, video production tutorials"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Video Blog", path: "/blog" },
        ]}
      />
      <section className="yv-container">
        <Reveal>
          <p className="yv-eyebrow">Yellow Video Blog</p>
          <h1 className="yv-h1 mt-3 max-w-4xl">
            Notes from Liverpool's<br />
            <span style={{ color: "var(--yellow)" }}>video production company.</span>
          </h1>
          <p className="text-white/70 max-w-2xl mt-5 text-lg leading-relaxed">
            Real pricing, real lessons, and case studies from the films we've made.
          </p>
        </Reveal>
      </section>

      <section className="yv-container mt-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOG_POSTS.map((p, i) => (
            <Reveal key={p.slug} delay={i * 80}>
              <Link
                to={`/blog/${p.slug}`}
                className="group block bg-white/[0.02] border border-white/10 rounded-md overflow-hidden hover:border-[var(--yellow)] transition h-full"
                data-testid={`blog-card-${p.slug}`}
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
                </div>
                <div className="p-6">
                  <p className="text-white/40 text-xs uppercase tracking-widest mb-3">{p.readTime} · {new Date(p.publishedAt).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</p>
                  <h2 className="yv-h3 text-white mb-3 group-hover:text-[var(--yellow)] transition">{p.title}</h2>
                  <p className="text-white/65 text-sm leading-relaxed">{p.excerpt}</p>
                  <p className="text-[var(--yellow)] text-sm font-semibold mt-4 inline-flex items-center gap-1">
                    Read article <ArrowRight size={14} />
                  </p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
